import { render, staticRenderFns } from "./ModalCanNotCreateDocument.vue?vue&type=template&id=2764c222&scoped=true&"
import script from "./ModalCanNotCreateDocument.vue?vue&type=script&lang=ts&"
export * from "./ModalCanNotCreateDocument.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCanNotCreateDocument.vue?vue&type=style&index=0&id=2764c222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764c222",
  null
  
)

export default component.exports